module.exports = __webpack_public_path__ + "img/abo5.6dbbf4fc.jpg";